"use client";

// Ported from next-themes to the SPA's own provider (see src/lib/theme.tsx).
import { useTheme } from "@/lib/theme";
import { Toaster as Sonner, toast } from "sonner";

// CargoFL ShadCN Library — Toaster (sonner).
type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          // A refusal has to stand out from "Saved" at a glance: tinted, not solid,
          // so a long message stays readable. Opaque mixes rather than /10
          // opacity, or the page shows through the toast.
          error:
            "border-destructive/60! bg-[color-mix(in_srgb,var(--color-destructive)_10%,var(--color-background))]! text-destructive! font-medium",
          success:
            "border-success/50! bg-[color-mix(in_srgb,var(--color-success)_8%,var(--color-background))]!",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
